import moment from "moment";
import { getOrderAdjustments } from "../../Shared/components/OrderSummary/orderSummary-utils";
import { getOrderSummaryDates } from "./getOrderSummaryDates";
// TODO: Order info type is broken.
// TODO: Remove unused vars.
export const buildOrderSummary = (order, orderInfo) => {
    var _a;
    const orderSummary = {
        orderNumber: order.OrderNumber,
        orderId: order.OrderId,
        balance: orderInfo.balance || orderInfo.Balance,
        planName: order.ProgramName,
        startDate: moment(order.StartDate).format("YYYY-MM-DD"),
        subscriptionPeriod: orderInfo.subscription_period,
        omissions: orderInfo.Preferences.map((p) => ({ name: p, id: 0 })) || [],
        // Only recipe types with an id greater than 0 should display
        recipeTypeName: orderInfo.recipe_type_id && orderInfo.recipe_type_id > 0 ? orderInfo.recipe_type_name : undefined,
        mealSize: undefined,
        postalCode: orderInfo.ZipCode,
        location: !!orderInfo.location_name ? orderInfo.location_name.trim() : "",
        totalDayBankValue: orderInfo.TotalDayBankValue,
        appliedDayBanks: orderInfo.AppliedDayBanks,
        additionalItems: orderInfo.additional_items,
        // A number of values are missing in the incoming data.
        dates: getOrderSummaryDates(orderInfo),
        discounts: {
            subscription: {
                value: orderInfo.subscription_discount,
                appliedValue: orderInfo.subscription_discount_amount,
            },
            coupons: getOrderAdjustments(orderInfo.balance),
        },
        tax: orderInfo.tax,
        taxRate: orderInfo.tax_rate,
        shipping: orderInfo.shipping,
        subtotal: orderInfo.subtotal,
        total: orderInfo.total,
        fullDayDiscount: orderInfo.fullDayDiscount,
        subscriptions: {
            products: (_a = orderInfo.subscription_products) === null || _a === void 0 ? void 0 : _a.filter((subProduct) => subProduct.Quantity > 0 && subProduct.RenewAlways).map((subProduct) => {
                var _a;
                //Subscription product is missing info so get it from the product_items
                const productInfo = orderInfo.product_items.find((p) => p.productId === subProduct.ProductId);
                return {
                    name: productInfo === null || productInfo === void 0 ? void 0 : productInfo.name,
                    quantity: subProduct.Quantity,
                    id: subProduct.ProductId,
                    price: productInfo === null || productInfo === void 0 ? void 0 : productInfo.cost,
                    sale: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.SalePrice) !== 0 ? subProduct.SalePrice : undefined,
                    dayOfWeek: (_a = subProduct.DayOfWeek) !== null && _a !== void 0 ? _a : -1,
                };
            }),
            meals: orderInfo.days.map((day) => {
                var _a, _b;
                const targetMealsForDay = (_b = (_a = orderInfo.subscription_templates) === null || _a === void 0 ? void 0 : _a.filter((template) => template.day_of_week === moment(day.delivery_date).day())) !== null && _b !== void 0 ? _b : [];
                return {
                    day: moment(day.delivery_date).day(),
                    meals: targetMealsForDay.map((meal) => {
                        var _a;
                        return {
                            name: meal.programMealName,
                            quantity: meal.quantity,
                            price: (_a = meal.mealCost) !== null && _a !== void 0 ? _a : 0,
                        };
                    }),
                };
            }),
        },
        isSubscription: (order === null || order === void 0 ? void 0 : order.SubscriptionStatus) === 10,
        sku: orderInfo.FlowSku ? orderInfo.FlowSku : orderInfo.program_sku,
        // TODO -- these values are not present in the incoming data.
        // nextOrderSubtotal: 0,
        isFutureOrder: false,
    };
    return orderSummary;
};
